import React from 'react';
import { Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { OvertimeFactor } from './OvertimeFactor';
import { DoubleTimeFactor } from './DoubleTimeFactor';
import { HolidayFactor } from './HolidayFactor';
import { payRateModStyles } from '../PayRateMod.styles';
import { CallBackFactor } from './CallbackFactor';

export const PayFactor = ({ isExpanded, isModEdit }: { isExpanded: boolean; isModEdit: boolean }) => {
  const { t } = useTranslation();
  const { classes } = payRateModStyles({ isExpanded });

  return (
    <Grid style={{ marginTop: '24px' }}>
      <div>
        <Typography component="span" className={classes.headings}>{`${t(
          'placement.placementMods.payFactors',
        )}`}</Typography>
      </div>
      <Grid className={classes.flex}>
        <OvertimeFactor classes={classes} isModEdit={isModEdit} />
        <DoubleTimeFactor classes={classes} isModEdit={isModEdit} />
        <HolidayFactor classes={classes} isModEdit={isModEdit} />
        <CallBackFactor classes={classes} isModEdit={isModEdit} />
      </Grid>
    </Grid>
  );
};
